import { render, staticRenderFns } from "./ImportarVacinas.vue?vue&type=template&id=2bc8ad4e"
import script from "./ImportarVacinas.vue?vue&type=script&lang=js"
export * from "./ImportarVacinas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports